import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export type OpenHouseSerializableProperties = ReturnType<typeof OpenHouse.prototype.toJSON>;

export class OpenHouse {
  to: string | null;
  from: string | null;
  date: string | null;

  constructor(openHouse: Record<string, unknown>) {
    this.to = openHouse.to as string | null ?? null;
    this.from = openHouse.from as string | null ?? null;
    this.date = openHouse.date as string | null ?? null;
  }

  toJSON() {
    return {
      to: this.to,
      from: this.from,
      date: this.date,
    };
  }

  get isActive() {
    if (this.date) {
      const date = new Date(this.date);
      const hoursMatch = this.to?.match(/^(\d+):/);
      if (hoursMatch) {
        date.setHours(parseInt(hoursMatch[1], 10) + (this.to?.match(/pm/i) ? 12 : 0));
      }
      const minutesMatch = this.to?.match(/:(\d+)/);
      if (minutesMatch) {
        date.setMinutes(parseInt(minutesMatch[1], 10));
      }
      return date > new Date();
    }
    return false;
  }
}
